var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServlets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill-rule: evenodd;\n      }\n\n      .cls-4 {\n        fill: #eaeaea;\n      }\n\n      .cls-2, .cls-5 {\n        fill: #3275b9;\n      }\n\n      .cls-5 {\n        font-family: Poppins-SemiBold, Poppins;\n        font-size: 16.8px;\n        font-weight: 600;\n      }\n\n      .cls-5, .cls-6 {\n        isolation: isolate;\n      }\n\n      .cls-3 {\n        fill: #ca3232;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -1.9,
    y: -1.8,
    width: 87.8,
    height: 99.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4803.7-375.5h2500v2500h-2500V-375.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.1,58.5s-2.8,1.6,2,2.2c5.8.7,8.8.6,15.2-.6,0,0,1.7,1.1,4,2-14.3,6.1-32.5-.4-21.2-3.5h0ZM28.4,50.5s-3.1,2.3,1.7,2.8c6.2.6,11.1.7,19.6-.9,0,0,1.2,1.2,3,1.8-17.3,5.1-36.7.4-24.3-3.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.2,36.9c3.5,4.1-.9,7.7-.9,7.7,0,0,9-4.6,4.9-10.4-3.8-5.4-6.8-8.1,9.2-17.4,0,0-25.1,6.3-13.1,20.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.1,64.4s2.1,1.7-2.3,3c-8.3,2.5-34.5,3.3-41.7,0-2.6-1.1,2.3-2.7,3.8-3,1.6-.3,2.5-.3,2.5-.3-2.9-2-18.8,4-8.1,5.8,29.2,4.7,53.3-2.1,45.7-5.6h0ZM31.5,42.1s-13.3,3.2-4.7,4.3c3.6.5,10.9.4,17.6-.2,5.5-.5,11-1.5,11-1.5,0,0-1.9.8-3.3,1.8-13.5,3.6-39.7,1.9-32.1-1.7,6.4-3.1,11.5-2.7,11.5-2.7h0ZM55.4,55.5c13.7-7.1,7.4-14,3-13.1-1.1.2-1.6.4-1.6.4,0,0,.4-.6,1.2-.9,8.8-3.1,15.5,9.1-2.8,13.9,0,0,.2-.2.3-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.1,1.8s7.6,7.6-7.2,19.3c-11.9,9.4-2.7,14.8,0,20.9-6.9-6.3-12-11.8-8.6-16.9,5-7.5,18.9-11.2,15.9-23.3h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.8,74.9c13.2.8,33.5-.5,33.9-6.7,0,0-.9,2.4-10.9,4.2-11.3,2.1-25.2,1.9-33.4.5,0,0,1.7,1.4,10.4,2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(7.9 91.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Servlets")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServlets);
export default __webpack_public_path__ + "static/media/Servlets.668943cffebc5367293ce555b9370310.svg";
export { ForwardRef as ReactComponent };